export default {
    "FACTSHEET": "Factsheet",
    "DASHBOARD": "Dashboard",
    "DATACOMICS": "DataComics",
    "DATAVIDEOS": "DataVideos",
    "H5": "H5",
    "TIMESEIRES":'TimeSeries'
}